// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lFrE","buttons":"styles_buttons__3AVba"};